import { useAppSelector } from '@/hooks/useAppSelector';
import { selectUser } from '@/slice/user';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Form, Input, message, Typography } from 'antd';
import { updateAdminProfile } from 'src/api/consultants';
import { SvgIcon } from 'src/components/icon';
import {formRules} from "@/helpers/formRules";

export default function PersonalInformation() {
  const user = useAppSelector(selectUser);
  const queryClient = useQueryClient();

  const { mutateAsync: updateProfile, isPending } = useMutation({
    mutationFn: ({
      firstName,
      lastName,
      email,
    }: {
      firstName: string;
      lastName: string;
      email: string;
    }) => updateAdminProfile(firstName, lastName, email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      message.success('Profile updated successfully!');
    },
    onError: (error: any) => {
      console.log(error);
      message.error(
        error.message || 'Profile update failed. Please try again.',
      );
    },
  });

  const generateErrorMessage = (errorText: string) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <SvgIcon type={'alert'} />
        <Typography.Text style={{ color: '#F46262' }}>
          {errorText}
        </Typography.Text>
      </div>
    );
  };
  const onFinish = async (values: any) => {
    updateProfile(values);
  };
  return (
    <div>
      <Form
        layout="vertical"
        name="basic"
        onFinish={onFinish}
        className="admin-forgot-form"
        validateTrigger="onSubmit"
        initialValues={{
          firstName: user?.firstName || '',
          lastName: user?.lastName || '',
          email: user?.email || '',
        }}
      >
        <Form.Item
          name="firstName"
          label={<label style={{ color: '#9FA1AD' }}>First Name</label>}
        >
          <Input placeholder="Enter here" className="admin-input-text" />
        </Form.Item>
        <Form.Item
          name="lastName"
          label={<label style={{ color: '#9FA1AD' }}>Last Name</label>}
        >
          <Input placeholder="Enter here" className="admin-input-text" />
        </Form.Item>
        <Form.Item
          name="email"
          label={<label style={{ color: '#9FA1AD' }}>Email</label>}
          rules={formRules.EMAIL(generateErrorMessage('Please input a valid email!'))}
        >
          <Input placeholder="Enter here" className="admin-input-text" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            className="admin-forgot-button"
            disabled={isPending}
            loading={isPending}
          >
            Save Changes
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
